import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { UserPlus } from "lucide-react";
import { useMemo, useState } from "react";
import { getManagerInitials } from "../hooks/useCampaignManagers";
import { CampaignManagersModal } from "./CampaignManagersModal";
import styles from "./CampaignManagersTeamButton.module.scss";

const AVATAR_COLORS = [
  styles.avatarPurple,
  styles.avatarSky,
  styles.avatarGreen,
];

export function CampaignManagersTeamButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { brief } = useBriefStore();

  const selectedManagers = useMemo(() => {
    return (brief?.brandOrganisationManagers ?? []).map((m) => ({
      id: m.userId,
      name: `${m.user.firstName} ${m.user.lastName}`.trim(),
    }));
  }, [brief?.brandOrganisationManagers]);

  const visibleManagers = selectedManagers.slice(0, 3);
  const overflowCount = Math.max(selectedManagers.length - 3, 0);

  return (
    <>
      <button
        type="button"
        className={styles.teamButton}
        onClick={() => setIsOpen(true)}
      >
        <span className={styles.avatarStack}>
          {visibleManagers.map((manager, index) => (
            <span
              key={manager.id}
              className={`${styles.avatar} ${AVATAR_COLORS[index % AVATAR_COLORS.length]}`}
            >
              {getManagerInitials(manager.name)}
            </span>
          ))}
          {selectedManagers.length === 0 ? (
            <span className={`${styles.avatar} ${styles.emptyAvatar}`}>
              <UserPlus size={11} />
            </span>
          ) : null}
          {overflowCount > 0 ? (
            <span className={`${styles.avatar} ${styles.overflowAvatar}`}>
              +{overflowCount}
            </span>
          ) : null}
        </span>
        Team
        {selectedManagers.length > 0 ? (
          <span className={styles.count}>({selectedManagers.length})</span>
        ) : null}
      </button>

      <CampaignManagersModal open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
